
const modalManageLicenseId = (productId, licenseTypeId) => {
  return 'msync-org-manage-license-' + productId + '-' + licenseTypeId
}
const modalConfirmationMessageId = 'msync-modal-license-confirmation-message'

const handleLicensesConfirmationModal = ( id, info, hasModal = null, setSelectedUser, setSelectedModal, teamType = 'wooteams' ) => {

  if( ! id || ! info ) return null
  setSelectedModal( '' )

  if( hasModal !== null ){
    MicroModal.close( hasModal )
    setSelectedModal( hasModal )
  }
  info.teamType = teamType
  setSelectedUser( info )
  MicroModal.show( id )
  
}

export{
  modalManageLicenseId,
  modalConfirmationMessageId,
  handleLicensesConfirmationModal
}
